import { AutogenModelOfferSource, AutogenRowOfferSource } from "./autogen/AutogenModelOfferSource";

export class ModelOfferSource extends AutogenModelOfferSource<RowOfferSource> {
    constructor() {
        super(RowOfferSource);
    }
}

export class RowOfferSource extends AutogenRowOfferSource {
}